/// Filename: public/custom-elements/sampleEvent.js 
// **********************************************
// Custom Element Code in Corvid
// **********************************************

const LOGO_IMG = 'https://canadiantire.scene7.com/is/image/CanadianTire/1871769_1';

const createImg = (id, src) => {

var imageElement =  document.getElementById(id);

if (typeof(imageElement) != 'undefined' && imageElement != null)
{
   //console.log(src);
   imageElement.src = src;
   return imageElement;

  //element Exists.
}

  const img = document.createElement('img');
  img.src = src;
  img.id = id;
  img.width = '250';
  img.height = '250';
  img.display = 'blocked';
  img.style.backgroundColor = '#FFFFF';
  img.class = 'img-responsive';
  img.loading = 'eager';
  img.style.objectFit = 'scale-down';
  //img.style.objectFit = 'cover';
  //img.backgroundSize = 'contain';

  return img;

}
 // myImage = this.swhoopImageElement;
 // return myImage;


var loaded = false;
//var img = 
class myLargeProductDisplay extends HTMLElement {
   constructor() 
   {
     super();
     loaded = true;
     //console.log(loaded + "wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww")
     this.dispatchEvent(new CustomEvent('load'));


     // var shwoopImageElement = createImg('shwoop-image', LOGO_IMG);

     //this.appendChild(createImg('shwoop-image', LOGO_IMG));
     //createImg("shwoopImage", LOGO_IMG);
    // this.addEventListener('load', (event) => {
     //  console.log("page is loaded");
     //  loaded = true;
     //  })
      

   }

  connectedCallback() {
      
      //this.appendChild(new shwoopImageElement);
      
      //this.appendChild(createImg("shwoop-image", ""));
  }

onLoad(e)
{
//  console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^")
}

attributeChangedCallback(name, oldValue, newValue) 
{   
    if (name === 'showimage') 
    {
      var url = "";
      var tag = "";

      var splitArray = newValue.toString().split(" ");

      if(splitArray.length === 2)
      {     
        url =  splitArray[0];
        tag =  splitArray[1];
      }
      else
      {
        url = newValue;
      }

      this.appendChild(createImg("swhoop-image" + tag, url));
      //shwoopImageCount++;
    } 
}

  // Code for a special lifecycle function `observedAttributes()`
  // that checks specific attributes on the page. 
    static get observedAttributes() {
    return ['showimage'];
  }

}

customElements.define('my-large-image-display', myLargeProductDisplay ); // ,// {extends:"img"});
// ************************************************
// Custom Element's Result
// ************************************************
//<my-custom-element>Hello World!</my-custom-element>